import {isEmpty} from 'lodash';
// Import Actions
import {
  REQUEST_NEWSLETTER_ADD,
  NEWSLETTER_ADD_FAILURE,
  NEWSLETTER_ADD_SUCCESS,
} from '../actions/FooterActions';

// Initial State
const initialState = {
  isRegisteringForNewsletter: false,
  newsletter: {},
};

const FooterReducers = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_NEWSLETTER_ADD:
      return {
        ...state,
        isRegisteringForNewsletter: action.isRegisteringForNewsletter,
      };

    case NEWSLETTER_ADD_FAILURE:
      return {
        ...state,
        isRegisteringForNewsletter: action.isRegisteringForNewsletter,
      };

    case NEWSLETTER_ADD_SUCCESS:
      return {
        ...state,
        isRegisteringForNewsletter: action.isRegisteringForNewsletter,
      };

    default:
      return state;
  }
};

/* Selectors */
// Get showAddPost

// Export Reducer
export default FooterReducers;
